var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine5Cup0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41751 7.66481C2.63781 5.24882 2.74796 4.04083 3.30423 3.11804C3.79355 2.30634 4.5164 1.6464 5.36918 1.23282C6.33867 0.762634 7.55167 0.762634 9.97768 0.762634H26.4383C28.8644 0.762634 30.0774 0.762634 30.9611 1.23282C31.7385 1.6464 32.341 2.30634 32.6823 3.11804C33.0702 4.04083 32.9601 5.24882 32.7398 7.66481L31.2451 24.0575C31.0248 26.4735 30.9146 27.6815 30.3583 28.6042C29.869 29.4159 29.1462 30.0759 28.2934 30.4895C27.3239 30.9596 26.1109 30.9596 23.6849 30.9596H7.22423C4.79822 30.9596 3.58521 30.9596 2.70147 30.4895C1.92411 30.0759 1.32161 29.4159 0.980324 28.6042C0.592333 27.6815 0.702482 26.4735 0.922779 24.0575L2.41751 7.66481Z",
    fill: "#09060F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1391 12.5674C19.7332 12.5674 20.8652 13.5839 20.6111 16.2639L20.2183 20.0989C20.0104 22.155 18.7629 23.4488 16.3602 23.4488C13.611 23.4488 12.6637 21.9471 12.941 19.2903L13.1027 17.7655H15.5054L15.2975 19.7293C15.1819 20.7458 15.5516 21.254 16.4064 21.254C17.2381 21.254 17.5153 20.6765 17.6077 19.8448L18.0005 16.0559C18.0929 15.2011 17.7694 14.6467 17.0302 14.6467C16.2678 14.6467 15.8288 15.178 15.7133 16.2177L15.6902 16.4256H13.2875L14.2116 7.60035H21.1424L20.9114 9.7489H16.3833L15.9674 13.6533H15.9905C16.4295 12.9371 17.1457 12.5674 18.1391 12.5674Z",
    fill: "#ECEAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine5Cup0);
export default __webpack_public_path__ + "static/media/line-5-cup-0.c14f53134e0330f384f3897868f46fe8.svg";
export { ForwardRef as ReactComponent };